import VerticalCatalogCard from "@components/Features/catalog/vertical-catalog-card/vertical-catalog-card";
import { BlogOffersProps } from "./types";
import classes from "./blog-offers.module.scss";

export const BlogOffers = ({ offers }: BlogOffersProps) => {
    return (
        <div className={classes["blog-offers"]}>
            {offers.map((item, id) => {
                return (
                    <div key={id}>
                        <VerticalCatalogCard data={item} />
                    </div>
                );
            })}
        </div>
    );
};